import { isMostCriticalDates } from './detectConflictDates';

export function updateConflictStatusOnDelete(parentTask) {
  const activityRef = parentTask;

  if (!activityRef) return;
  if (activityRef.tasks.length < 1) {
    const gantt = window.ganttVisualization;
    const ganttActivity = gantt.getTask(activityRef.unique_id);
    ganttActivity.requestState = null;
    gantt.updateTask(ganttActivity.id);
  } else {
    isMostCriticalDates(activityRef);
  }
}

export function detectedChildrenWhitPending(gantt, taskId) {
  const children = gantt.getChildren(taskId);

  for (const childId of children) {
    const child = gantt.getTask(childId);
    if (child.modificationSource === 'pending') {
      return true;
    }
    const hasPendingDescendant = detectedChildrenWhitPending(gantt, childId);
    if (hasPendingDescendant) {
      return true;
    }
  }
  return false;
}
